module.exports = __webpack_public_path__ + "img/live-text.e204a65b.png";